export default __webpack_public_path__ + "static/media/left_trees.08d8e732.svg";